export default "dist/images/block-number-box-faded.7af88a2.png";